<template>
	<v-btn @click="dialog = !dialog" color="warning" dark>
		<v-icon small dark class="mr-1">add_box</v-icon>
		Thu Khác
		<v-dialog v-model="dialog" max-width="80%">
			<app-card>
				<app-section-loader :status="loading"></app-section-loader>
				<h4>PHIẾU THU KHÁC</h4>
				<p class="fs-14 grey--text">Tạo phiếu thu khác</p>
				<v-form ref="form">
					<v-container fluid>
						<p class="fs-14 grey--text">Mã chứng từ: {{ form.receipt_id }}</p>
						<v-layout row wrap justify-center>
							<v-flex xs12 md3>
								<v-select
									label="Tòa nhà"
									:disabled="loading"
									v-model="form.building"
									:items="list_building"
									prepend-icon="domain"
									:rules="[rules.required]"
									required
								></v-select>
							</v-flex>
							<v-flex xs12 md3>
								<v-menu
									:close-on-content-click="false"
									v-model="menu_month_picker"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="form.month"
										label="Chọn tháng"
										:disabled="loading"
										prepend-icon="event"
										readonly
										:rules="[rules.required]"
									></v-text-field>
									<v-date-picker
										min="2019-10"
										locale="vi-VI"
										type="month"
										v-model="form.month"
										@input="menu_month_picker = false"
									></v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex xs12 md3>
								<v-menu
									:close-on-content-click="false"
									v-model="menu_date_collected"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="form.date_collected"
										label="Ngày thu"
										:disabled="loading"
										prepend-icon="event"
										readonly
										:rules="[rules.required]"
									></v-text-field>
									<v-date-picker
										locale="vi-VI"
										v-model="form.date_collected"
										@input="menu_date_collected = false"
									></v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									label="Số chứng từ giấy"
									v-model="form.paper_receipt_number"
									prepend-icon="label"
									required
									:rules="[rules.required, rules.isNaturalNumber]"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									label="Số tiền thu"
									:disabled="loading"
									v-model="form.collected_amount"
									prepend-icon="money"
									required
									:rules="[rules.required]"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md9>
								<v-text-field
									label="Ghi chú"
									:disabled="loading"
									v-model="form.note"
									prepend-icon="event_note"
									:rules="[rules.required]"
								>
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn :disabled="loading" @click="cancelInput">
							Trở về
						</v-btn>
						<v-btn
							:loading="loading"
							:disabled="loading"
							@click="submit"
							color="primary"
						>
							Tạo Phiếu Thu
						</v-btn>
					</v-card-actions>
				</v-form>
			</app-card>
		</v-dialog>
	</v-btn>
</template>

<script>
import api from "Api";
import { list_building, BUILDING_TO_CASH_ACCOUNT_ID_MAPPING } from "Constants/db-config";
import { Wallet } from "Components/Form";

export default {
	name: "dialog-tao-phieu-thu-khac",
	components: {
		Wallet
	},
	data() {
		return {
			dialog: false,
			loading: false,
			menu_month_picker: false,
			menu_date_collected: false,
			rules: {
				required: value => !!value || "Vui lòng điền thông tin này.",
				isNaturalNumber: value =>  /^[1-9]\d*$/.test(value.replace(/,/g, '')) || "Mã chứng từ phải là số",
			},
			form: {
				receipt_id: "",
				paper_receipt_number: "",
				building: "",
				date_collected: "",
				note: "",
				month: "",
				collected_amount: "",
				wallet_account_id: null,
			},
			list_building,
			list_first_collectors: [
				{ text: "BVBN", value: "BVBN" },
				{ text: "BVGB", value: "BVGB" },
				{ text: "BVTT", value: "BVTT" },
				{ text: "BVXA", value: "BVXA" },
				{ text: "BVMA", value: "BVMA" },
				{ text: "BVBMT", value: "BVBMT" }
			]
		};
	},
	watch: {
		"form.collected_amount": function(nv, ov) {
			this.formatMoney();
		},
		"form.building": function(nv, ov) {
            if (nv) {
                if (this.form.paper_receipt_number) this.form.receipt_id = nv + '.' + this.form.paper_receipt_number + ".KHAC";
                this.form.wallet_account_id = BUILDING_TO_CASH_ACCOUNT_ID_MAPPING[nv];
            }
        },
        "form.paper_receipt_number": function(nv, ov) {
            if (nv && this.form.building) {
                this.form.receipt_id = this.form.building + '.' + nv + ".KHAC"; 
            }
        },
	},
	methods: {
		formatMoney: function() {
			let collected_amount = this.form.collected_amount;
			collected_amount = collected_amount
				? collected_amount
						.toString()
						.replace(/,/g, "")
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: 0;
			this.form.collected_amount = collected_amount;
		},
		cancelInput() {
			this.dialog = false;
			this.$refs.form.reset();
		},
		submit: async function() {
			if (!this.$refs.form.validate()) {
				swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
				return;
			}

			this.loading = true;

			const postData = {
				...this.form,
				date_collected: new Date(this.form.date_collected),
				collected_amount: Number(
					this.form.collected_amount.replace(/,/g, "")
				)
			};

			const data = await api.createReceiptOther(postData);

			this.loading = false;

			if (data.status === 200) {
				this.dialog = false;
				this.cancelInput();
				this.$emit("getData");
				swal.fire("Thành công", data.data.message, "success");
			} else swal.fire("Lỗi", data.message, "error");
		}
	}
};
</script>

<style>
</style>